import styled from "styled-components";

import listIcon from "../../../../assets/MayoClinicInfo/List.svg";
import bloodThinnersIcon from "../../../../assets/Mayo/blood_thinners.svg";
import iodineIcon from "../../../../assets/Mayo/iodine.svg";
import checkIcon from "../../../../assets/Mayo/checkmark.png";

import videoThumbnail from "../../../../assets/Mayo/thumbnail3.jpg";
import foodImg from "../../../../assets/temp/food.png";


import ListBox from "../common/ListBox";
import MedInstruction from "../common/MedInstruction";
import MayoLogo from "../common/MayoLogo";
import MayoInquery from "../common/MayoInquery";
import FastingInstructionsFeed from "../common/FastingInstructionsFeed";
import MayoContactSection from "../common/ContactSection";
import MayoVideoHeader from "../common/MayoVideoHeader";
import MayoVisitInfo from "../common/MayoVisitInfo";
import MayoFooter from "../common/MayoFooter";
import MayoGetAround from "../common/MayoGetAround";
import SoapInstructions from "../common/SoapInstructions";
import bgImg from "../../../../assets/Mayo/bg_1_for_videe_pages.svg"
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { usePatientFacing } from "../../../../flow/patientFacing/hooks/usePatientFacing";
import { EVENT_LOCATIONS } from "../consts";

const MED_INST_LIST = [
  {margin: "0 16px 20px 0", iconStyle: {height: 26, width: 18, marginRight: 20}, icon: bloodThinnersIcon, text: "If you are using antiplatelet agents such as Aspirin, Plavix, Effient, or Brilinta - there is no requirement to discontinue these medications before your procedure."},
  {margin: "0 16px 20px 0", iconStyle: {height: 26, width: 18, marginRight: 20}, icon: bloodThinnersIcon, text: "If you are on blood thinners, a nursing team will call you to provide instructions on when to stop taking these medications. Please follow their instructions."},
  {margin: "0 16px 0 0", iconStyle: {height: 26, width: 18, marginRight: 20}, icon: iodineIcon, text: "If you’re allergic to iodine, please contact us."}
]
const FASTING_INSTRUCTIONS_LIST = [
  {
    title: "8 hours before arrival time:",
    eat: ["Continue to drink plenty of liquids."],
    dontEat: ["Stop eating solid food.", "Do not drink beverages that contain alcohol.", "Do not use e-cigarettes or tobacco products. This includes chewing tobacco."]
  },
  {
    title: "6 hours before arrival time:",
    eat: ["Continue to drink plenty of clear liquids, such as:", "Water / Coffee or tea with no milk or creamer / Clear fruit juice, such as apple, cranberry or grape juice / Carbonated beverages / Sport drinks, such as Gatorade / Clear, fat-free broth.", "* Gelatin, such as JELL-O", "* Ice pops / Popsicles with no pulp", "* Pedialyte"],
    dontEat: ["Stop drinking any non-clear liquids, such as:", "Milk, including soy and almond milk / Orange or tomato juice."]
  },
  {
    title: "2 hours before arrival time:",
    eat: null,
    dontEat: ["Stop drinking anything"]
  },
]

const TUBE_FASTING_INSTRUCTIONS_LIST = [
  {
    title: "6 hours before arrival time:",
    instructions: ["Stop giving feedings through the tube.",
      "You may continue to give plenty of water or other clear liquids through the tube."],
  },
  {
    title: "2 hours before arrival time:",
    instructions: ["Stop giving water and other clear liquids through the tube."],
  },
]

const BRING_LIST = [
  {margin: "0 15px 10px 0",icon: checkIcon, iconStyle: {height: 11, width: 15, marginRight: 12, marginTop: 7}, text: "Insurance cards."},
  {margin: "0 15px 10px 0",icon: checkIcon, iconStyle: {height: 11, width: 15, marginRight: 12, marginTop: 7}, text: "Pharmacy and drugs benefit cards."},
  {margin: "0 15px 10px 0",icon: checkIcon, iconStyle: {height: 11, width: 15, marginRight: 12, marginTop: 7}, text: "Driver license or other photo identification card."},
  {margin: "0 15px 10px 0",icon: checkIcon, iconStyle: {height: 11, width: 15, marginRight: 12, marginTop: 7}, text: "Bring your advance directive if you have one."},
  {margin: "0 15px 10px 0",icon: checkIcon, iconStyle: {height: 11, width: 15, marginRight: 12, marginTop: 7}, text: "Bring your medications with you, in their original bottles."},
  {margin: "0 15px 10px 0",icon: checkIcon, iconStyle: {height: 11, width: 15, marginRight: 12, marginTop: 7}, text: "If you have an implanted medical device, bring any documentation associated."},
  {margin: "0 15px 0px 0",icon: checkIcon, iconStyle: {height: 11, width: 15, marginRight: 12, marginTop: 7}, text: "Arrange for an adult to accompany you to and from your procedure, you will not be able to drive yourself."},
]

const POST_PROCEDURE_LIST = [
  {margin: "0 5px 15px 0",icon: checkIcon, iconStyle: {height: 11, width: 15, marginRight: 12, marginTop: 7}, text: "Take all your previous prescribed medications, including aspirin, as you normally do unless your physician tells you otherwise."},
  {margin: "0 5px 15px 0",icon: checkIcon, iconStyle: {height: 11, width: 15, marginRight: 12, marginTop: 7}, text: "Do not lift objects, weighing more than 10 pounds (about the weight of a gallon of milk), for 10 days"},
  {margin: "0 5px 15px 0",icon: checkIcon, iconStyle: {height: 11, width: 15, marginRight: 12, marginTop: 7}, text: "Do not do strenuous exercise (biking, weight lifting, aerobics, golfing)."},
  {margin: "0 5px 15px 0",icon: checkIcon, iconStyle: {height: 11, width: 15, marginRight: 12, marginTop: 7}, text: "Do not strain."},
  {margin: "0 5px 15px 0",icon: checkIcon, iconStyle: {height: 11, width: 15, marginRight: 12, marginTop: 7}, text: "Ask your health care provider when you can exercise again or take part in sexual intercourse."},
  {margin: "0 5px 15px 0",icon: checkIcon, iconStyle: {height: 11, width: 15, marginRight: 12, marginTop: 7}, text: "Showering is allowed 24 hours after your procedure - You may remove the bandage but do not scrub the insertion site or take a bath for 7 days or until your groin site is healed."},
  {margin: "0 5px 0 0",icon: checkIcon, iconStyle: {height: 11, width: 15, marginRight: 12, marginTop: 7}, text: "Keep the insertion site clean and dry and do not use powders or creams on it."},
]

const POST_PROCEDURE_WARNING_SIGNS = [
  {margin: "0", icon: checkIcon, iconStyle: {height: 10, width: 5, marginRight: 18, marginTop: 5}, text: "New or expanding swelling."},
  {margin: "0", icon: checkIcon, iconStyle: {height: 10, width: 5, marginRight: 18, marginTop: 5}, text: "Pain or discomfort at the puncture site."},
  {margin: "0", icon: checkIcon, iconStyle: {height: 10, width: 5, marginRight: 18, marginTop: 5}, text: "Signs of infection (redness, drainage, fever)."},
  {margin: "0", icon: checkIcon, iconStyle: {height: 10, width: 5, marginRight: 18, marginTop: 5}, text: "Change in color, temperature or sensation in the arm or leg that is the site of the puncture."},
  {margin: "0", icon: checkIcon, iconStyle: {height: 10, width: 5, marginRight: 18, marginTop: 5}, text: "Unusual feeling of weakness or faintness."},
]

export default function MayoVideoPage2TAVR() {
  const { getEventDataLocal } = usePatientFacing();
  const event = getEventDataLocal();
  const { surgery } = event?.Case?.CardiologyCase || {};
  const location = EVENT_LOCATIONS[event?.facingType]; // TODO - add data

  return (
    event &&
    <Container>
      <MayoLogo/>

      <MayoVideoHeader 
        postAnalyticType={"watchedVideoTAVR"}
        title={"Watch the video to better prepare for your upcoming TAVR procedure"}
        videoThumbnail={videoThumbnail}
      />

      <HL/>

      <MayoVisitInfo 
        procedureText={"You are scheduled for a TAVR procedure on"}
        procedureDate={surgery}
        address1={location.address1}
        address2={location.address2}
      />

      <HL style={{marginBottom: 35}}/>

      <ListBox
        style={{paddingBottom: 35}}
        headerMargin="26px 0 24px 0"
        title={"Prior to your TAVR procedure please follow these important medication instructions"}
        list={MED_INST_LIST}
        Component={MedInstruction}
      />

      <ListBox
        style={{marginTop: 34, paddingRight: 18, paddingLeft: 25}}
        headerMargin="0 0 21px 0"
        title={"Fasting instruction"}
        TitleIcon={<Icon 
          src={foodImg}
          width={70} height={56} />
        }
        subtitle={"This outlines when and what you can eat and drink leading up to your procedure."}
        list={[{generalFastingInstructions: FASTING_INSTRUCTIONS_LIST, tubeFastingInstructions: TUBE_FASTING_INSTRUCTIONS_LIST}]}
        Component={FastingInstructionsFeed}
      />

      <ListBox
        style={{marginTop: 34, marginBottom: 52, paddingRight: 17, paddingBottom: 41}}
        headerMargin="0 0 24px 0"
        title={"On the day of your procedure don’t forget to bring:"}
        TitleIcon={<Icon
            style={{marginLeft: 8}}
            src={listIcon}
            width={70} height={70}
          />
        }
        list={BRING_LIST}
        Component={MedInstruction}
      />

      <HL/>

      <RecommendationText>
        It is recommended to leave<br/> valuable items at home. such as large amounts of cash, expensive jewelry, unnecessary electronics, irreplaceable items, and excessive credit cards.
      </RecommendationText>

      <HL/>

      <SoapInstructions style={{marginBottom: 15}}/>

      <MayoInquery style={{marginBottom: 45}}/>

      <HL/>

      <MayoGetAround style={{marginTop: 15, marginBottom: 30}}/>

      <HL style={{marginBottom: 35}}/>
      <MayoContactSection />
      <HL style={{marginTop: 37}}/>

      <MayoFooter />

    </Container>
  )
}

const Container = styled.div`
  color: #1A1A1A;
  font-family: Abraham;
  min-height: 100vh;
  background-image: url("${bgImg}");
  background-repeat: repeat;
  background-size: cover;
  background-position: center;
`

const RecommendationText = styled.p`
  font-size: 19px;
  margin-top: 36px;
  margin-bottom: 37px;
  margin-right: 25px;
  margin-left: 26px;
  font-weight: 400;
`

const Image = styled.img``

const Quote = styled.p`
  font-size: 24px;
  font-weight: 400;
`

const Icon = styled.img` 
`

const HL = styled.div`
  height: 1px;
  background-color: #82A4FC;
  opacity: 0.2;
  margin-inline: 15px;
`